import {Component, ElementRef, ViewChild} from '@angular/core';
import {AuthService} from "../../../../services/auth.service";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";

@Component({
  selector: 'app-logout-modal',
  templateUrl: './logout-modal.component.html',
  styleUrls: ['./logout-modal.component.scss']
})
export class LogoutModalComponent {

  @ViewChild('closeLogoutButton') closeLogoutButton!: ElementRef;
  isLoading: boolean = false

  constructor(
    private authService: AuthService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private router: Router
  ) {
  }

  logout(): void {
    this.isLoading = true;
    this.authService.logout().subscribe({
      next: value => {
        this.isLoading = false;
        this.toastr.success(this.translate.instant('LOGOUT.TOASTR_SUCCESS_MESSAGE'), this.translate.instant('LOGOUT.TOASTR_SUCCESS_H1'), {toastClass: 'ngx-toastr yourclass'});
        this.authService.resetUserSession();
      },
      error: err => {
        console.error(err)
        this.isLoading = false;
        // this.toastr.error(err.message, this.translate.instant('LOGOUT.TOASTR_FAILED_H1'), {toastClass: 'ngx-toastr yourclass'})

        let toastrErrorMessage:string;
        if (err.error && err.error.message){
          // if there is a rival error message ex. API method error
          toastrErrorMessage = `${err.error.message}`
        } else if (err.message) {
          //other errors, like bad API url, no internet
          toastrErrorMessage = err.message
        } else {
          //fallback case for non-descriptive errors
          console.error(err)
          toastrErrorMessage = this.translate.instant('LOGIN.TOASTR_ERROR_LOGGEDOUT_TIP')
        }
        this.toastr.error(toastrErrorMessage, this.translate.instant('LOGOUT.TOASTR_FAILED_H1'), {toastClass: 'ngx-toastr yourclass'})
      },
      complete: () => {
        //after successful next OR expired token error handled in interceptor by sending EMPTY
        this.isLoading = false;
      }
    });
    this.closeLogoutButton.nativeElement.click();

    this.router.navigate(['']);
  }

}
